'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive("itTreeTableSpacer", function () {
  return {
    restrict: "E",
    replace: true,
    scope: true,
    require: ["^infiniTable", "^itTreeTableRow"],
    template: '<div class="spacer"></div>',
    link: function link($scope, $el, $attrs, controllers) {
      var tableCtrl = controllers[0],
        rowCtrl = controllers[1],
        config = tableCtrl.getConfig(),
        lastClass = null,
        depth,
        index,
        upwardCount,
        isLastSpacer,
        spacerRowMeta;
      var update = function update() {
        depth = $scope.depth;
        index = $scope.$spacerIdx;
        upwardCount = depth - index; // - 1;
        isLastSpacer = upwardCount === 0;
        var node = rowCtrl.getNode();
        for (var i = 0; i < upwardCount; i++) {
          node = node.parent;
        }
        spacerRowMeta = node.$node;
      };
      $scope.$on("recompute-spacer", function () {
        update();
        recomputeSpacer();
      });
      var recomputeSpacer = function recomputeSpacer() {
        if (!spacerRowMeta) {
          return; // TODO : see why this is appening...
        }
        var noRootLines = config.noRootLines;
        var hasNextSibling = !spacerRowMeta.$last;
        var newClass = null;
        if (isLastSpacer) {
          if (hasNextSibling) {
            if (noRootLines && depth === 0) {
              newClass = config.spacerNoneClass;
            } else {
              newClass = config.spacerCrossClass;
            }
          } else {
            if (noRootLines && depth === 0) {
              newClass = config.spacerNoneClass;
            } else {
              newClass = config.spacerCornerClass;
            }
          }
        } else {
          if (hasNextSibling) {
            if (noRootLines && depth >= 1 && index === 0) {
              newClass = config.spacerNoneClass;
            } else {
              newClass = config.spacerLineClass;
            }
          } else {
            newClass = config.spacerNoneClass;
          }
        }
        $el.removeClass(lastClass).addClass(newClass);
        lastClass = newClass;
      };
      update();
      recomputeSpacer();
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/infiniTable/tree/itTreeTableSpacer.js
// module id = 2824
// module chunks = 13